import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../../../axios';
import { moduleName } from '../../moduleInfo';
import {
  createDiscountRoute,
  getApprovalsTableRoute,
  viewDiscountRoute,
} from '../../utils/apiRoutes';

export const createUpdateDiscountAsync = (name = '') =>
  createAsyncThunk(`${moduleName}/${name}`, async (payload) => {
    console.log(payload);
    const response = await axios({
      method: 'PUT',
      url: createDiscountRoute(),
      data: payload,
    });
    const data = response.data;
    return data;
  });

export const createDiscountAsync = createUpdateDiscountAsync('createDiscount');
export const updateDiscountAsync = createUpdateDiscountAsync('updateDiscount');

export const viewDiscountAsync = createAsyncThunk(
  `${moduleName}/viewDiscount`,
  async (payload) => {
    const response = await axios({
      method: 'GET',
      url: viewDiscountRoute(),
      params: payload,
    });
    const data = response.data;
    return data;
  }
);

export const getApprovalsTableAsync = createAsyncThunk(
  `${moduleName}/getApprovalsTableAsync`,
  async (payload) => {
    const response = await axios({
      method: 'GET',
      url: getApprovalsTableRoute(),
      params: payload,
    });
    const data = response.data;
    return data;
  }
);

const discountSlice = createSlice({
  name: `${moduleName}/ManagementAppApproval`,
  initialState: {
    loading: false,
    activeDiscounts: [],
    inactiveDiscounts: [],
    approvalsTable: null,
  },
  reducers: {},
  extraReducers: {
    [createDiscountAsync.pending]: (state, action) => {
      state.loading = true;
      //todo
    },
    [createDiscountAsync.fulfilled]: (state, action) => {
      state.loading = false;
      //todo
    },
    [createDiscountAsync.rejected]: (state, action) => {
      state.loading = false;
      //todo
    },
    [updateDiscountAsync.pending]: (state, action) => {
      //todo
    },
    [updateDiscountAsync.fulfilled]: (state, action) => {
      const discount = action.payload.data;
      state.activeDiscounts = state.activeDiscounts.filter(
        (discountItem) => discountItem._id !== discount._id
      );
      state.inactiveDiscounts = [discount, ...state.inactiveDiscounts];
    },
    [updateDiscountAsync.rejected]: (state, action) => {
      //todo
    },
    [viewDiscountAsync.pending]: (state, action) => {
      state.activeDiscounts = [];
      state.inactiveDiscounts = [];
      state.loading = true;
    },
    [viewDiscountAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.activeDiscounts = action.payload.activeDiscounts || [];
      state.inactiveDiscounts = action.payload.inactiveDiscounts || [];
    },
    [viewDiscountAsync.rejected]: (state, action) => {
      state.loading = false;
      console.log(action.payload);
    },
    [getApprovalsTableAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [getApprovalsTableAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.approvalsTable = action.payload.data;
    },
    [getApprovalsTableAsync.rejected]: (state, action) => {
      state.loading = false;
    },
  },
});

export default discountSlice.reducer;
